import { render } from "./Publications.vue?vue&type=template&id=6dc3d7dc&scoped=true"
import script from "./Publications.vue?vue&type=script&lang=js"
export * from "./Publications.vue?vue&type=script&lang=js"

import "./Publications.vue?vue&type=style&index=0&id=6dc3d7dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc3d7dc"]])

export default __exports__